import { Component, OnInit } from '@angular/core';
import { animate, state, style, transition, trigger } from "@angular/animations";

@Component({
    selector: 'say-button',
    templateUrl: './button.component.html',
    styleUrls: ['./button.component.css'],
    animations: [
        trigger('testTrigger', [
            state('open', style({
                overflow: 'hidden',
                height: '*'
            })),
            state('closed', style({
                overflow: 'hidden',
                height: '0px',
                padding: '0px',
                'min-height': '0px'
            })),
            transition('closed => open', animate('250ms ease-in-out')),
            transition('open => closed', animate('250ms ease-in-out'))
        ])
    ]
})
export class ButtonComponent implements OnInit {

    public state: string = 'closed';
    constructor() {
    }

    ngOnInit() {
        setTimeout(() => {
            this.state = 'open';
        }, 5000);
    }
}
